import messages from 'containers/ProvisionalClaimsPage/messges';

export const REQUEST_ADD_PROVISIONAL_CLAIM = 'REQUEST_ADD_PROVISIONAL_CLAIM';
export const REQUEST_GET_PROVISIONAL_CLAIM = 'REQUEST_GET_PROVISIONAL_CLAIM';
export const REQUEST_SET_PROVISIONAL_CLAIMS = 'REQUEST_SET_PROVISIONAL_CLAIMS';
export const PROVISIONAL_STATUS_MESSAGES = {
  PENDING: messages.ProvisionalClaimStatusPending,
  MAPPED: messages.ProvisionalClaimStatusMapped,
};
